export enum ERROR_CODES {
  // Authentication & Authorization
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  INVALID_OLD_PASSWORD = 'INVALID_OLD_PASSWORD',
  RESET_TOKEN_EXPIRED = 'RESET_TOKEN_EXPIRED',
  RESET_TOKEN_INVALID = 'RESET_TOKEN_INVALID',
  LOGIN_METHOD_MISMATCH = 'LOGIN_METHOD_MISMATCH',
  PASSWORD_SAME_AS_OLD = 'PASSWORD_SAME_AS_OLD',

  // User Management
  USER_INACTIVE = 'USER_INACTIVE',
  USER_EMAIL_EXISTS = 'USER_EMAIL_EXISTS',
  USER_ALREADY_HAS_RECOVERY_LINK = 'USER_ALREADY_HAS_RECOVERY_LINK',
  USER_IS_SUPERVISOR = 'USER_IS_SUPERVISOR',
  USER_ALREADY_REGISTERED = 'USER_ALREADY_REGISTERED',
  LAST_ORG_ADMIN = 'LAST_ORG_ADMIN',
  USER_NOT_A_GYM_USER = 'USER_NOT_A_GYM_USER',
  USER_NOT_AN_APP_USER = 'USER_NOT_AN_APP_USER',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_INVITED = 'USER_ALREADY_INVITED',
  EXTERNAL_USER_NOT_FOUND = 'EXTERNAL_USER_NOT_FOUND',
  EXTERNAL_USER_NO_EMAIL = 'EXTERNAL_USER_NO_EMAIL',
  SUPERVISOR_NOT_ASSIGNED = 'SUPERVISOR_NOT_ASSIGNED',

  // Reservations
  USER_HAS_FUTURE_RESERVATIONS = 'USER_HAS_FUTURE_RESERVATIONS',
  RESERVATION_IS_IN_REST_HOUR = 'RESERVATION_IS_IN_REST_HOUR',
  RESERVATION_IS_OUTSIDE_ALLOWED_HOURS = 'RESERVATION_IS_OUTSIDE_ALLOWED_HOURS',
  EXTERNAL_USER_HAS_CONFLICTING_RESERVATIONS = 'EXTERNAL_USER_HAS_CONFLICTING_RESERVATIONS',
  RESERVATION_FULL = 'RESERVATION_FULL',
  COUPON_NOT_ENOUGH_USES = 'COUPON_NOT_ENOUGH_USES',
  BRANCH_HAS_CONFLICTING_RESERVATION = 'BRANCH_HAS_CONFLICTING_RESERVATION',
  RESERVATION_CANCELLATION_TIME_LIMIT_PASSED = 'RESERVATION_CANCELLATION_TIME_LIMIT_PASSED',
  RESERVATION_ALREADY_STARTED = 'RESERVATION_ALREADY_STARTED',
  RESERVATION_NOT_FOUND = 'RESERVATION_NOT_FOUND',
  RESERVATION_TYPE_NOT_FOUND = 'RESERVATION_TYPE_NOT_FOUND',
  BRANCH_NOT_FOUND = 'BRANCH_NOT_FOUND',
  COUPON_NOT_FOUND = 'COUPON_NOT_FOUND',
  USER_COUPON_NOT_FOUND = 'USER_COUPON_NOT_FOUND',
  COUPON_INACTIVE = 'COUPON_INACTIVE',
  COUPON_IN_USE = 'COUPON_IN_USE',
  PARTICIPANT_NOT_FOUND = 'PARTICIPANT_NOT_FOUND',
  PARTICIPANT_NOT_IN_QUEUE = 'PARTICIPANT_NOT_IN_QUEUE',
  PARTICIPANT_ALREADY_CANCELED = 'PARTICIPANT_ALREADY_CANCELED',
  EXTERNAL_USER_ALREADY_IN_RESERVATION = 'EXTERNAL_USER_ALREADY_IN_RESERVATION',
  RESERVATION_ALREADY_CANCELED = 'RESERVATION_ALREADY_CANCELED',
  RESERVATION_NOT_IN_FUTURE = 'RESERVATION_NOT_IN_FUTURE',
  CANNOT_CLONE_CANCELED_RESERVATION = 'CANNOT_CLONE_CANCELED_RESERVATION',
  RESERVATION_TYPE_NOT_CLONEABLE = 'RESERVATION_TYPE_NOT_CLONEABLE',
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  RESERVATION_NOT_ALLOWED_BY_TYPE = 'RESERVATION_NOT_ALLOWED_BY_TYPE',

  // Resources
  RESOURCE_WITH_SAME_NAME_EXISTS = 'RESOURCE_WITH_SAME_NAME_EXISTS',
  RESOURCE_IN_USE = 'RESOURCE_IN_USE',

  // Routines
  ROUTINE_NOT_FOUND = 'ROUTINE_NOT_FOUND',
  EXERCISE_NOT_FOUND = 'EXERCISE_NOT_FOUND',
  ROUTINE_ALREADY_ASSIGNED = 'ROUTINE_ALREADY_ASSIGNED',
  ROUTINE_CANNOT_FINISH = 'ROUTINE_CANNOT_FINISH',
  NO_ACTIVE_ROUTINE = 'NO_ACTIVE_ROUTINE',

  // Roles, tickets, signed documents and features
  ROLE_NOT_FOUND = 'ROLE_NOT_FOUND',
  TICKET_NOT_FOUND = 'TICKET_NOT_FOUND',
  SIGNED_DOCUMENT_NOT_FOUND = 'SIGNED_DOCUMENT_NOT_FOUND',
  SIGNED_DOCUMENT_ALREADY_REVOKED = 'SIGNED_DOCUMENT_ALREADY_REVOKED',
  SIGNING_DATA_MISSING = 'SIGNING_DATA_MISSING',
  FEATURE_NOT_ENABLED = 'FEATURE_NOT_ENABLED',

  // Request validation
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  FILE_UPLOAD_INVALID = 'FILE_UPLOAD_INVALID',

  // App Version
  APP_VERSION_TOO_LOW = 'APP_VERSION_TOO_LOW',

  // Surveys
  SURVEY_FORM_INCOMPLETE = 'SURVEY_FORM_INCOMPLETE',
  SURVEY_ALREADY_ACTIVE = 'SURVEY_ALREADY_ACTIVE',
  SURVEY_LAUNCH_NOT_ACTIVE = 'SURVEY_LAUNCH_NOT_ACTIVE',
  SURVEY_ALREADY_ANSWERED = 'SURVEY_ALREADY_ANSWERED',
  SURVEY_TRANSLATION_UNAVAILABLE = 'SURVEY_TRANSLATION_UNAVAILABLE',
  SURVEY_TRANSLATION_FAILED = 'SURVEY_TRANSLATION_FAILED',

  // OTA bundle version (separate from the store app version above)
  OTA_BUNDLE_VERSION_TOO_LOW = 'OTA_BUNDLE_VERSION_TOO_LOW',
}

export type ErrorCode = keyof typeof ERROR_CODES;
